import Chip from '@mui/material/Chip';
import { t } from 'i18next';

interface TimesheetStatusChipProps {
  aiProcessed: boolean;
}

// The backend has no timesheet state machine yet — the only signal for "has the AI vision
// extraction run?" is the `ai_processed` boolean, so the chip is derived from that alone.
export default function TimesheetStatusChip({ aiProcessed }: TimesheetStatusChipProps) {
  return (
    <Chip
      color={aiProcessed ? 'success' : 'default'}
      label={
        aiProcessed
          ? t('approvals.timesheets.status_extracted')
          : t('approvals.timesheets.status_processing')
      }
      size="small"
      sx={{ fontWeight: 500 }}
    />
  );
}
